import React, { useEffect } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import './DeliveryConditionsPage.scss'
import { useGetLocationsQuery } from '../../store/api/locationsApi'
import { ILocation } from '../../types/locations'
import { getStorageKey } from '../../utils/appType'

const c = 'delivery-conditions-page'

const DeliveryConditionsPage = () => {
  const generalInfo = JSON.parse(
    localStorage.getItem(getStorageKey('info')) || '{}',
  )
  const { t, i18n } = useTranslation()
  const { data: locations = [] } = useGetLocationsQuery()

  const getTranslatedName = (item: ILocation) => {
    if (i18n.language === 'ru' && item?.label_ru) {
      return item.label_ru
    }

    return item.label
  }

  useEffect(() => {
    window.scrollTo({ top: 700, behavior: 'smooth' })
  }, [])

  return (
    <div className={c}>
      <div className={`${c}__schedule`}>
        <Trans
          i18nKey='DELIVERY_SCHEDULE'
          values={{
            minTime: generalInfo?.minTime,
            maxTime: generalInfo?.maxTime,
          }}
        />
      </div>
      <div className={`${c}__subtitle`}>{t('LOCATION_PRICE')}:</div>
      <div className={`${c}__locations`}>
        {locations?.map((location: ILocation) => (
          <div key={location._id} className={`${c}__locations-location`}>
            <div className={`${c}__locations-location-label`}>
              {getTranslatedName(location)}
            </div>
            -
            <div className={`${c}__locations-location-value`}>
              {location.delivery_price} lei
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default DeliveryConditionsPage
